export const MenuData = [
  {title : 'About', link : '/about'},
  {title : 'Trips', link : '/trips'},
  {title : 'Careers', link : '/career'},
  {title : 'Contact', link : '/contact'},

];
